/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取剧院焦点轮播图
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: cms.TheaterBannerDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cms/theater/dongyi-banners`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
